import React, { useContext, useEffect, useState } from 'react';

import { observer } from "mobx-react-lite";
import Agent from "../../api/Agent";
import { displayDate } from "../../lib/utilities";
import { RootStoreContext } from "../../stores/RootStore";
import Autocomplete from "../Inputs/Autocomplete";
import { ComboBoxProps, OptionType } from "./ComboBox";
import { IMaintenanceRepair } from 'models/MaintenanceRepair/MaintenanceRepair';

interface OwnProps extends Omit<ComboBoxProps, 'options'> {
  filterIds?: string[]
  entityStateId?: string
  canAddNew?: boolean
  onFetchSuccess?:(data: IMaintenanceRepair[]) => void
}

type Props = OwnProps

const MaintenanceRepairAutoCompleteInput: React.FC<Props> = ({entityStateId, filterIds, canAddNew= true, onFetchSuccess, ...rest}) => {

  // Mobx
  const rootStore = useContext(RootStoreContext)
  const {maintenanceRepairsList} = rootStore.maintenanceRepairStore
  const {openModal} = rootStore.modalStore

  // local state
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([] as OptionType[]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = new URLSearchParams()
        params.append('limit', '100000')
        params.append('offset', `0`)
        const {modelsDto} = await Agent.MaintenanceRepair.list(params)
        if (modelsDto && modelsDto.length > 0 ) onFetchSuccess && onFetchSuccess(modelsDto)
        setAutoCompleteOptions(() => {
          const opts = modelsDto
          .filter(opt => opt.entityStateId === entityStateId || !entityStateId)
          .map(opt => {
            return {
              id: opt.id,
              name: `${opt.consumerName ?? 'Inventory'} - ${opt.equipmentName ?? 'No Equipment'} (${displayDate(opt.datePerformed) ?? 'No Date'})`.trim()
            }
          })
          .sort((optA, optB) => optA.name > optB.name ? 1 : -1)

          // @ts-ignore
          if (canAddNew) opts.unshift({id: 0, name: '+ New Maintenance/Repair'})
          return opts
        })

      } catch (e) {

      }
    }

    fetchData()
  }, [maintenanceRepairsList, entityStateId]);


  const createNew = () => {
    openModal('MaintenanceRepairModal', {header: 'New MaintenanceRepair'})
  }

  const handleChange = (e) => {
    return e.id === 0 ? createNew() : !!rest.onChange && rest?.onChange(e)
  }

  const optionsFilter = (option) => {
    if (filterIds) {
      return !filterIds.includes(option.id)
    } else {
      return true;
    }
  }

  return (
    <Autocomplete {...rest} options={autoCompleteOptions.filter(opt => optionsFilter(opt))} label={'Maintenance/Repair'}
      onChange={handleChange}></Autocomplete>
  );
};
export default observer(MaintenanceRepairAutoCompleteInput);
